import {
  RESET_PASSWORD_DIALOG_OPEN,
  RESET_PASSWORD_DIALOG_CLOSE
} from "types/actions/reset-password-dialog"

export const openResetPasswordDialog = (loggedin = false) => ({
  type: RESET_PASSWORD_DIALOG_OPEN,
  open: true,
  loggedin: loggedin
})

export const closeResetPasswordDialog = data => ({
  type: RESET_PASSWORD_DIALOG_CLOSE,
  open: false
})



// WEBPACK FOOTER //
// ./src/actions/reset-password-dialog.js